<template>
  <div v-if="isMe" class="col-10 col-md-6 my-3 align-self-end">
    <div class="d-flex justify-content-end m-0">
      <div
          @click.prevent="openCall"
          class="mw-lg-400px align-content-center position-relative cursor-pointer send">
       <div class="d-flex align-items-center">
         <i class="fa fa-phone-alt fs-3 me-5" :class="'text-'+call?.status_formatted?.color" ></i>
         <span v-if="callEnums.IN_PROGRESS === call?.status">
           {{ $t('chat.call.your_calling') }} {{ receiver?.name }}
         </span>
         <span v-if="callEnums.ENDED === call?.status"> {{ $t('chat.call.call_ended') }} </span>
         <span v-if="callEnums.CANCELED === call?.status"> {{ $t('chat.call.call_without_answer') }} </span>
       </div>
        <span class="position-absolute text-muted bottom-0 end-0 mb-n5">
          {{ getDateHour(call?.created_at) }}
        </span>
      </div>
      <div class="col-1 d-flex align-self-stretch  justify-content-end">
        <AvatarBadge class="mt-auto" :avatar-url="call.from?.avatar && call.from?.avatar_url" :fullname="call.from?.fullname"  />
      </div>
    </div>
  </div>
  <div v-else class="col-10 col-md-6 my-2 align-self-start">
    <div class="d-flex justify-content-end m-0">
      <div class="col-1 d-flex align-self-stretch">
        <AvatarBadge class="mt-auto" :avatar-url="call.from?.avatar && call.from?.avatar_url" :fullname="call.from?.fullname"  />
      </div>
      <div
          class="mw-lg-400px align-content-center position-relative cursor-pointer receive"
      >
        <div class="d-flex align-items-center">
          <i class="fa fa-phone-alt fs-3 me-5" :class="'text-'+call?.status_formatted?.color" ></i>
          <span v-if="callEnums.IN_PROGRESS === call?.status">
            {{ $t('chat.call.join_call_link') }}: <span class="text-primary">  {{ call?.link }}</span>

            <br>
            <span v-if="isGroup" class="d-flex mt-2">
               <span @click.prevent="acceptCall" class="btn btn-success btn-sm me-2">
                  Join
              </span>
            </span>
            <span v-else class="d-flex mt-2">
               <span @click.prevent="acceptCall" class="btn btn-success btn-sm me-2">
                  Accept
              </span>
              <span @click.prevent="declineCall" class="btn btn-danger btn-sm">
                  Decline
              </span>
            </span>
         </span>
          <span v-if="callEnums.ENDED === call?.status"> {{ $t('chat.call.call_ended') }} </span>
          <span v-if="callEnums.CANCELED === call?.status"> {{ $t('chat.call.missed_call') }} </span>
        </div>
        <span class="position-absolute text-muted bottom-0 end-0 mb-n5">
          {{ getDateHour(call?.created_at) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>

import AvatarBadge from "@/components/AvatarBadge.vue";
import {useChatEnums} from "@/Modules/Chat/composables/chatEnums";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {normaliserTexte, stopCallSound} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import {MEET_DOMAIN} from "@/services/meetService";

const { locale } = useLocales()
const store = useStore()
const route = useRoute()
const { callEnums } = useChatEnums()

const props = defineProps({
  call: {
    type: Object,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  isGroup: {
    type: Boolean,
    required: true
  }
})

const callWindow = ref(null)
const jitsi = ref(null)

const isMe = computed(() => props.call.from_id === props.user?.id)

function getDateHour(date) {
  return new Date(date).toLocaleTimeString(locale.value, {
    hour: '2-digit',
    minute: '2-digit'
  })
}
const openCall = () => {
  if(props.call.status === callEnums.value.IN_PROGRESS) {
    callWindow.value = window.open(
        `${props.call.link}#userInfo.displayName="${encodeURIComponent(props.user.fullname)}"`,
        "callWindow", 'width=800,height=600,resizable=yes'
    )
    callWindow.value.document.close();


    const script = callWindow.value.document.createElement("script");
    script.src = `https://${MEET_DOMAIN}/external_api.js`;
    script.onload = () => initializeJitsi(callWindow.value, props.call.link.toString().replace(`https://${MEET_DOMAIN}/`, ''));
    callWindow.value.document.head.appendChild(script);
  }
}

const initializeJitsi = (callWindow, name) => {
  const meetContainer = callWindow.document.getElementById("meet");
  if (!meetContainer) {
    console.error("Impossible de trouver #meet dans la fenêtre d'appel.");
    return;
  }

  const options = {
    userInfo: {
      displayName: props.user.fullname || '',
    },
    parentNode: meetContainer,
    roomName: normaliserTexte(name),
    devices: ['audio', 'video'],
    configOverwrite: {
      prejoinPageEnabled: false,
    },
    lang: locale.value,
    width: "100%",
    height: "100%"
  };

  jitsi.value = new callWindow.JitsiMeetExternalAPI(MEET_DOMAIN, options);

  jitsi.value.addEventListener('readyToClose', stopCall);
};

const acceptCall = () => {
  store.dispatch('chat/joinCall', {
    id: props.call.id,
    conversation_id: route.params.id
  })
      .then(res => {
        let callLink = `${props.call.link}#userInfo.displayName="${encodeURIComponent(props.user.fullname)}"&configOverwrite.prejoinPageEnabled="false"`;

        window.open(
            callLink,
            "callWindow", 'width=800,height=600,resizable=yes'
        )
        stopCallSound()
      })
      .catch(err => {

      })
      .finally()
}
const declineCall = () => {
  store.dispatch('chat/rejectCall',{
    id: props.call.id,
    conversation_id: route.params.id
  })
      .then(res => {
        stopCallSound()
      })
      .catch(err => {
      })
      .finally()
}

const stopCall = () =>  {
  if(callWindow.value) {
    callWindow.value.close()
    callWindow.value = null
  }
  jitsi.value?.removeListener('readyToClose', () => {})
  jitsi.value?.dispose();
}

</script>

<style scoped>


.send {
  padding: 15px;
  border-radius: 10px 10px 0 10px;
  background-color: #0072CE0D;
  min-height: 15px;
}

.receive {
  padding: 15px;
  border-radius: 10px 10px 10px 0;
  background-color: #F7F7F7;
  min-height: 15px;
}

</style>